import AboutUsContainer from "../features/Inicio/About/AboutUsContainer/AboutUsContainer"
import AvalContainer from "../features/Inicio/Aval/AvalContainer/AvalContainer"
import LandingHero from "../features/Inicio/LandingHero/LandingHero";
import './Inicio.css'
import ContactBanner from "../features/Inicio/ContactBannerFolder/ContactBanner"
import TestimonialGrid from "../features/Inicio/TestimonialSectionFolder/TestimonialGrid/TestimonialGrid";
import NewsCarousel from "../features/Inicio/NewsCarouselFolder/NewsCarousel/NewsCarousel";
import TeamContainer from "../features/Inicio/Team/TeamContainer/TeamContainer";
import MainLayout from "../layouts/MainLayout/MainLayout";
import SponsorSection from "../features/AboutUsPage/SponsorSection/SponsorSection";
import PromotionModal from "../components/PromotionModal/PromotionModal";
import {Button} from "@mantine/core";
import { IconPhone} from "@tabler/icons-react";

const Inicio = () => {
    // CHeck by date if the promotion modal should be active
    const isPromotionModalActive = new Date() <= new Date("2024-12-01") && new Date() >= new Date("2024-11-20");
    const handleContactSales = () => {
        window.location.href = "https://wa.me/5493518571139/?text=Hola!%20Quiero%20más%20información%20sobre%20la%20promo%20de%20Black%20Friday";
    };

    // const handleDownloadPDF = () => {
    //     window.open("https://forvet-main.s3.sa-east-1.amazonaws.com/public/misc/cyber_monday_forvet.pdf", "_blank");
    // };


    return (
        <MainLayout overflow="hidden">
            {isPromotionModalActive &&
                <PromotionModal
                    title="🎉 Black Friday - Del 20 al 30 de Noviembre 🎉"
                    message={null}
                    courses={[]}
                    image={"https://i.imgur.com/aqnK27X.jpeg"}
                    actions={
                        <>
                            <Button leftIcon={<IconPhone/>} onClick={handleContactSales} color="#DF3576">
                                Consultar a ventas
                            </Button>
                        </>
                    }
                />
            }

            <section className="landing__section" style={{position: "relative"}}>
                <LandingHero/>
            </section>

         <section className="landing__section--noPadding">
            <AvalContainer />
         </section>

         <section className="landing__section">
            <NewsCarousel />
         </section>

         {/*   DISABLED SINCE IT IS NOW AVAILABLE ABOVE*/}
         {/*<section className="landing__section">*/}
         {/*   <SpecialtiesCarousel />*/}
         {/*</section>*/}

            <section className="landing__section">
                < SponsorSection/>
            </section>

         <section className="landing__section">
            <AboutUsContainer />
         </section>

            <section className="landing__section">
                <TeamContainer/>
            </section>
            <section className="landing__section">
                <TestimonialGrid/>
            </section>
            <section className="landing__section">
                <ContactBanner/>
            </section>
        </MainLayout>
    )
}
export default Inicio